import React, { Component } from 'react';
import FailedProcessing from '../../img/FailedProcessing.png';
import intl from "react-intl-universal";


class ErrorMessages extends Component {
    render() {
        return (
            <React.Fragment>
                <div style={{ marginTop: "80px" }}>
                <img className="UploadingImages" src={FailedProcessing} />
                <div style={{ marginTop: "80px", textAlign: 'center', color: '#141414', fontFamily: 'Ubuntu, Medium', fontSize: '18px' }}>
                    <h4 className="moreSpacefromTitleToTable">{this.props.errorMessageString}</h4>
                </div>
                <div style={{ marginTop: "40px", textAlign: 'center' }}>
                    <p style={{marginTop: '40px'}}>
                        {this.props.isSubLoginType ? 
                            intl.get("Please_Contact_Turflogic_Support")
                        : 
                            <>
                                {intl.get("PM_Cloud_ErrorMessagesPage_Generic_Error_Message_Description_1")} <u><a target='_blank' href={'https://support.skylinesoft.com/hc/en-us/requests/new?tf_subject=PM%20cloud%20processing&tf_anonymous_requester_email=' + this.props.userEmail + "&tf_360015036959=pm_cloud_processing&tf_description=Enter%20description%20here:%0A%0APackage-" + this.props.packageId + ";%20Userid-" + this.props.userEmail}>Skyline support team</a></u> {intl.get("PM_Cloud_ErrorMessagesPage_Generic_Error_Message_Description_2")}
                            </>
                        }
                    </p>
                </div>
            </div>
        </React.Fragment>
        );
    }
}

export default ErrorMessages;